import { useState } from "react";
import { ACCENT, ACCENT_LIGHT, ACCENT_MID } from "../constants/theme";

export default function Btn({ children, onClick, outline, style = {} }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick}
      onMouseOver={() => setHov(true)} onMouseOut={() => setHov(false)}
      style={{
        background: outline ? (hov ? ACCENT_LIGHT : "#fff") : (hov ? "#1d4ed8" : ACCENT),
        color: outline ? ACCENT : "#fff",
        border: outline ? `2px solid ${ACCENT}` : "none",
        borderRadius: 10, padding: "12px 26px", fontWeight: 700, fontSize: 15,
        cursor: "pointer", transition: "all 0.18s", display: "inline-flex",
        alignItems: "center", gap: 8, ...style
      }}>{children}</button>
  );
}
